import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <Link
      to={`/categories/${item?.slugPath || item?.slug}`}
      className="mosaic-panel text-decoration-none"
    >
      <div
        className="panel-bg"
        style={{ backgroundImage: `url(${item?.image})` }}
      />
      <div className="panel-overlay" />

      <div className="panel-info">
        <span className="white-tag">Explore</span>
        <h3 className="panel-heading">
          {item?.name} <span>Collection</span>
        </h3>
        <p className="panel-desc">
          Explore premium products for every need.
        </p>
        <button className="panel-cta-outline">Shop Now</button>
      </div>
    </Link>
  );
}

export default Card;